<div class="modal-body alert-modal warn">
  <div>
    If you exit now, without clicking Submit, the question will be marked incorrect.
  </div>
  <div>
    Are you sure you want to leave without submitting your answer?
  </div>
  <div class="mt-3 d-flex" ngbautofocus>
    <div class="ms-auto d-flex">
      <button type="button" class="ms-auto btn btn-sm btn-outline-secondary me-1 prompt-btn" (click)="cancel()">No, Continue</button>
      <button type="button" class="btn btn-sm btn-warning prompt-btn" (click)="confirm()">Yes, Leave</button>
    </div>
  </div>
</div>
